import { useDispatch, useSelector } from "react-redux";

// Базовые хуки (можно добавить типы при переходе на TS)
export const useAppDispatch = () => useDispatch();
export const useAppSelector = useSelector;

// Пользователь
export const useUser = () => useAppSelector((state) => state.user);

export const useIsAuth = () => {
  const user = useUser();
  return Boolean(user?.sessionId);
};

// Компания
export const useCompany = () => useAppSelector((state) => state.company);
export const useCompanyError = () =>
  useAppSelector((state) => state.companyError);
